import classNames from 'classnames'

import style from './DatesRange.module.scss'
import { DatesRangeFilter } from './DatesRangeFilter'

interface IProps {
    startDate: string | null
    endDate: string | null
    onSetStartDate: (date: string | null) => void
    onSetEndDate: (date: string | null) => void
    onGetInsuredsList: () => void
    classname?: string
}

export const DatesRange = (props: IProps) => {
    const { classname, endDate, startDate, onSetStartDate, onSetEndDate, onGetInsuredsList } = props
    return (
        <div className={classNames(style.container, classname)}>
            <div className={style.dateRangePickerContainer}>
                <DatesRangeFilter
                    startDate={startDate}
                    endDate={endDate}
                    onSetStartDate={onSetStartDate}
                    onSetEndDate={onSetEndDate}
                    onGetInsuredsList={onGetInsuredsList}
                />
            </div>
        </div>
    )
}
